import { getCookie } from '@mirai/data-sources';

export const getCookies = () => ({
  fbc: getCookie('_fbc') || null,
  fbp: getCookie('_fbp') || null,
});
